// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/assets/images/common/bg_menu_open.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/assets/images/home/bg_slogun.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/assets/images/home/bg_gb365.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../public/assets/images/home/img_section_02_hand.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/public/assets/images/contact/bg_visual.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/public/assets/images/contact/m_bg_water.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/public/assets/images/home/bg_gb365.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/public/assets/images/home/img_section_02_hand.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("/public/assets/images/product/bg_product.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("/public/assets/images/product/bg_visual.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("/public/assets/images/rnd/bg_visual.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("/src/assets/fonts/Montserrat-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("/src/assets/fonts/Montserrat-Thin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("/src/assets/fonts/Montserrat-ExtraLight.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("/src/assets/fonts/Montserrat-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("/src/assets/fonts/Montserrat-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("/src/assets/fonts/Montserrat-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("/src/assets/fonts/Montserrat-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("/src/assets/fonts/Montserrat-ExtraBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("/src/assets/fonts/Montserrat-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("/public/assets/images/contact/bg_water.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.3.3 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.pointer-events-none {
  pointer-events: none;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.left-0 {
  left: 0px;
}
.left-6 {
  left: 1.5rem;
}
.top-0 {
  top: 0px;
}
.top-5 {
  top: 1.25rem;
}
.bottom-\\[5\\%\\] {
  bottom: 5%;
}
.left-2\\/4 {
  left: 50%;
}
.right-0 {
  right: 0px;
}
.right-\\[25\\%\\] {
  right: 25%;
}
.top-1\\/2 {
  top: 50%;
}
.top-2\\/4 {
  top: 50%;
}
.z-10 {
  z-index: 10;
}
.z-30 {
  z-index: 30;
}
.z-50 {
  z-index: 50;
}
.m-\\[5px\\] {
  margin: 5px;
}
.mx-10 {
  margin-left: 2.5rem;
  margin-right: 2.5rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-\\[22px\\] {
  margin-bottom: 22px;
}
.ml-0 {
  margin-left: 0px;
}
.ml-\\[12px\\] {
  margin-left: 12px;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-\\[28px\\] {
  margin-left: 28px;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-24 {
  margin-top: 6rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-9 {
  margin-top: 2.25rem;
}
.mt-\\[1\\.9rem\\] {
  margin-top: 1.9rem;
}
.mt-px {
  margin-top: 1px;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.hidden {
  display: none;
}
.h-20 {
  height: 5rem;
}
.h-6 {
  height: 1.5rem;
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.\\!h-auto {
  height: auto !important;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-5 {
  height: 1.25rem;
}
.h-\\[100vw\\] {
  height: 100vw;
}
.h-\\[176px\\] {
  height: 176px;
}
.h-\\[198px\\] {
  height: 198px;
}
.h-\\[2\\.82rem\\] {
  height: 2.82rem;
}
.h-\\[26px\\] {
  height: 26px;
}
.h-\\[282px\\] {
  height: 282px;
}
.h-\\[6\\.5rem\\] {
  height: 6.5rem;
}
.h-\\[90vh\\] {
  height: 90vh;
}
.max-h-\\[479px\\] {
  max-height: 479px;
}
.max-h-\\[763px\\] {
  max-height: 763px;
}
.w-14 {
  width: 3.5rem;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-6 {
  width: 1.5rem;
}
.w-\\[calc\\(50\\%-6px\\)\\] {
  width: calc(50% - 6px);
}
.w-full {
  width: 100%;
}
.\\!w-auto {
  width: auto !important;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-5 {
  width: 1.25rem;
}
.w-\\[17px\\] {
  width: 17px;
}
.w-\\[20\\%\\] {
  width: 20%;
}
.w-\\[768px\\] {
  width: 768px;
}
.max-w-\\[1200px\\] {
  max-width: 1200px;
}
.max-w-\\[1920px\\] {
  max-width: 1920px;
}
.max-w-\\[210px\\] {
  max-width: 210px;
}
.max-w-\\[751px\\] {
  max-width: 751px;
}
.basis-\\[calc\\(33\\.3\\%-20px\\)\\] {
  flex-basis: calc(33.3% - 20px);
}
.-translate-x-2\\/4 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-2\\/4 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.resize {
  resize: both;
}
.appearance-none {
  appearance: none;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.items-stretch {
  align-items: stretch;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.gap-10 {
  gap: 2.5rem;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-y-auto {
  overflow-y: auto;
}
.break-keep {
  word-break: keep-all;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.border-2 {
  border-width: 2px;
}
.border-b-\\[2px\\] {
  border-bottom-width: 2px;
}
.border-\\[\\#F2F2F2\\] {
  --tw-border-opacity: 1;
  border-color: rgb(242 242 242 / var(--tw-border-opacity));
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.border-\\[\\#CDCDCD\\] {
  --tw-border-opacity: 1;
  border-color: rgb(205 205 205 / var(--tw-border-opacity));
}
.border-\\[\\#E4E3E3\\] {
  --tw-border-opacity: 1;
  border-color: rgb(228 227 227 / var(--tw-border-opacity));
}
.bg-\\[\\#171C30\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(23 28 48 / var(--tw-bg-opacity));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#103D80\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(16 61 128 / var(--tw-bg-opacity));
}
.bg-\\[\\#103D81\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(16 61 129 / var(--tw-bg-opacity));
}
.bg-\\[\\#F5F5F5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}
.bg-\\[url\\(\\"\\/public\\/assets\\/images\\/common\\/bg_menu_open\\.png\\"\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.bg-\\[url\\(\\"\\/public\\/assets\\/images\\/home\\/bg_slogun\\.jpg\\"\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-\\[url\\(\\"\\.\\.\\/public\\/assets\\/images\\/home\\/bg_gb365\\.png\\"\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.bg-\\[url\\(\\"\\.\\.\\/public\\/assets\\/images\\/home\\/img_section_02_hand\\.jpg\\"\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.bg-\\[url\\(\\"\\/public\\/assets\\/images\\/contact\\/bg_visual\\.jpg\\"\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.bg-\\[url\\(\\"\\/public\\/assets\\/images\\/contact\\/m_bg_water\\.jpg\\"\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.bg-\\[url\\(\\"\\/public\\/assets\\/images\\/home\\/bg_gb365\\.png\\"\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.bg-\\[url\\(\\"\\/public\\/assets\\/images\\/home\\/img_section_02_hand\\.jpg\\"\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.bg-\\[url\\(\\"\\/public\\/assets\\/images\\/product\\/bg_product\\.png\\"\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.bg-\\[url\\(\\"\\/public\\/assets\\/images\\/product\\/bg_visual\\.jpg\\"\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
.bg-\\[url\\(\\"\\/public\\/assets\\/images\\/rnd\\/bg_visual\\.jpg\\"\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
.from-\\[\\#DBE9FA\\] {
  --tw-gradient-from: #DBE9FA var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(219 233 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#ECEDEE\\] {
  --tw-gradient-from: #ECEDEE var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 237 238 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-\\[\\#EAF5FE\\] {
  --tw-gradient-to: #EAF5FE var(--tw-gradient-to-position);
}
.to-\\[\\#ffffff\\] {
  --tw-gradient-to: #ffffff var(--tw-gradient-to-position);
}
.bg-cover {
  background-size: cover;
}
.bg-center {
  background-position: center;
}
.p-3 {
  padding: 0.75rem;
}
.p-5 {
  padding: 1.25rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14 {
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-7 {
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-24 {
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-40 {
  padding-top: 10rem;
  padding-bottom: 10rem;
}
.py-\\[\\.94rem\\] {
  padding-top: .94rem;
  padding-bottom: .94rem;
}
.py-\\[3vw\\] {
  padding-top: 3vw;
  padding-bottom: 3vw;
}
.py-\\[4\\.4rem\\] {
  padding-top: 4.4rem;
  padding-bottom: 4.4rem;
}
.pb-24 {
  padding-bottom: 6rem;
}
.pt-16 {
  padding-top: 4rem;
}
.pb-12 {
  padding-bottom: 3rem;
}
.pb-20 {
  padding-bottom: 5rem;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pt-20 {
  padding-top: 5rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-\\[1\\.3rem\\] {
  font-size: 1.3rem;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-\\[1\\.4rem\\] {
  font-size: 1.4rem;
}
.text-\\[1rem\\] {
  font-size: 1rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.leading-4 {
  line-height: 1rem;
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-9 {
  line-height: 2.25rem;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-\\[1\\.25\\] {
  line-height: 1.25;
}
.leading-\\[1\\.4rem\\] {
  line-height: 1.4rem;
}
.leading-\\[4rem\\] {
  line-height: 4rem;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.text-\\[\\#274274\\] {
  --tw-text-opacity: 1;
  color: rgb(39 66 116 / var(--tw-text-opacity));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-\\[\\#103D80\\] {
  --tw-text-opacity: 1;
  color: rgb(16 61 128 / var(--tw-text-opacity));
}
.text-\\[\\#365DA5\\] {
  --tw-text-opacity: 1;
  color: rgb(54 93 165 / var(--tw-text-opacity));
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-0 {
  opacity: 0;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-700 {
  transition-duration: 700ms;
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}

@font-face {
  font-family: montserrat;
  font-style: normal;
  font-weight: 400;
  src: local('Montserrat'),
    url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('woff');
}

@font-face {
  font-family: montserrat;
  font-style: normal;
  font-weight: 250;
  src: local('Montserrat'),
    url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('woff');
}

@font-face {
  font-family: montserrat;
  font-style: normal;
  font-weight: 275;
  src: local('Montserrat'),
    url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('woff');
}

@font-face {
  font-family: montserrat;
  font-style: normal;
  font-weight: 300;
  src: local('Montserrat'),
    url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('woff');
}

@font-face {
  font-family: montserrat;
  font-style: normal;
  font-weight: 500;
  src: local('Montserrat'),
    url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('woff');
}

@font-face {
  font-family: montserrat;
  font-style: normal;
  font-weight: 600;
  src: local('Montserrat'),
    url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('woff');
}

@font-face {
  font-family: montserrat;
  font-style: normal;
  font-weight: 700;
  src: local('Montserrat'),
    url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format('woff');
}

@font-face {
  font-family: montserrat;
  font-style: normal;
  font-weight: 800;
  src: local('Montserrat'),
    url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format('woff');
}

@font-face {
  font-family: montserrat;
  font-style: normal;
  font-weight: 900;
  src: local('Montserrat'),
    url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format('woff');
}

html,
body {
  min-height: 100%;
  height: 100%;
  font-family: montserrat, sans-serif;
}
#root {
  height: 100%;
}

.swiper-slide-active .fade-01,
.swiper-slide-prev .fade-01 {
  opacity: 0;
  animation: fadeIn 1s ease-in-out forwards;
}

.swiper-slide-active .fade-02,
.swiper-slide-prev .fade-02 {
  opacity: 0;
  animation: fadeIn 1s ease-in-out forwards;
  animation-delay: 300ms;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(100px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.placeholder\\:text-base::placeholder {
  font-size: 1rem;
  line-height: 1.5rem;
}

.before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}

.before\\:left-2\\/4::before {
  content: var(--tw-content);
  left: 50%;
}

.before\\:top-2\\/4::before {
  content: var(--tw-content);
  top: 50%;
}

.before\\:mb-3::before {
  content: var(--tw-content);
  margin-bottom: 0.75rem;
}

.before\\:mb-\\[21px\\]::before {
  content: var(--tw-content);
  margin-bottom: 21px;
}

.before\\:block::before {
  content: var(--tw-content);
  display: block;
}

.before\\:inline-block::before {
  content: var(--tw-content);
  display: inline-block;
}

.before\\:h-12::before {
  content: var(--tw-content);
  height: 3rem;
}

.before\\:h-\\[3px\\]::before {
  content: var(--tw-content);
  height: 3px;
}

.before\\:h-\\[60px\\]::before {
  content: var(--tw-content);
  height: 60px;
}

.before\\:w-12::before {
  content: var(--tw-content);
  width: 3rem;
}

.before\\:w-\\[1px\\]::before {
  content: var(--tw-content);
  width: 1px;
}

.before\\:w-\\[80px\\]::before {
  content: var(--tw-content);
  width: 80px;
}

.before\\:-translate-x-2\\/4::before {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.before\\:-translate-y-2\\/4::before {
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.before\\:rounded-full::before {
  content: var(--tw-content);
  border-radius: 9999px;
}

.before\\:bg-\\[\\#000\\]::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}

.before\\:bg-black::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}

.before\\:opacity-0::before {
  content: var(--tw-content);
  opacity: 0;
}

.before\\:transition-opacity::before {
  content: var(--tw-content);
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.before\\:content-\\[\\"\\"\\]::before {
  --tw-content: "";
  content: var(--tw-content);
}

.checked\\:border-\\[\\#CDCDCD\\]:checked {
  --tw-border-opacity: 1;
  border-color: rgb(205 205 205 / var(--tw-border-opacity));
}

.checked\\:before\\:bg-\\[\\#365DA5\\]:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(54 93 165 / var(--tw-bg-opacity));
}

.hover\\:before\\:opacity-10:hover::before {
  content: var(--tw-content);
  opacity: 0.1;
}

.peer:checked ~ .peer-checked\\:opacity-100 {
  opacity: 1;
}

@media (min-width: 768px) {

  .md\\:right-\\[35\\%\\] {
    right: 35%;
  }

  .md\\:order-1 {
    order: 1;
  }

  .md\\:order-2 {
    order: 2;
  }

  .md\\:mx-\\[60px\\] {
    margin-left: 60px;
    margin-right: 60px;
  }

  .md\\:ml-28 {
    margin-left: 7rem;
  }

  .md\\:mt-10 {
    margin-top: 2.5rem;
  }

  .md\\:mt-5 {
    margin-top: 1.25rem;
  }

  .md\\:mt-8 {
    margin-top: 2rem;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:mt-6 {
    margin-top: 1.5rem;
  }

  .md\\:mt-7 {
    margin-top: 1.75rem;
  }

  .md\\:mt-\\[4\\.2rem\\] {
    margin-top: 4.2rem;
  }

  .md\\:block {
    display: block;
  }

  .md\\:inline-block {
    display: inline-block;
  }

  .md\\:inline {
    display: inline;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:\\!h-auto {
    height: auto !important;
  }

  .md\\:\\!h-full {
    height: 100% !important;
  }

  .md\\:h-\\[418px\\] {
    height: 418px;
  }

  .md\\:h-\\[554px\\] {
    height: 554px;
  }

  .md\\:h-auto {
    height: auto;
  }

  .md\\:h-full {
    height: 100%;
  }

  .md\\:w-\\[6\\.5rem\\] {
    width: 6.5rem;
  }

  .md\\:w-1\\/2 {
    width: 50%;
  }

  .md\\:w-\\[25\\%\\] {
    width: 25%;
  }

  .md\\:w-\\[3800px\\] {
    width: 3800px;
  }

  .md\\:w-\\[40\\%\\] {
    width: 40%;
  }

  .md\\:w-\\[45\\%\\] {
    width: 45%;
  }

  .md\\:w-\\[55\\%\\] {
    width: 55%;
  }

  .md\\:w-\\[60\\%\\] {
    width: 60%;
  }

  .md\\:flex-col {
    flex-direction: column;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:p-5 {
    padding: 1.25rem;
  }

  .md\\:px-20 {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .md\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .md\\:pb-24 {
    padding-bottom: 6rem;
  }

  .md\\:pb-56 {
    padding-bottom: 14rem;
  }

  .md\\:pt-40 {
    padding-top: 10rem;
  }

  .md\\:pl-10 {
    padding-left: 2.5rem;
  }

  .md\\:pl-\\[15\\%\\] {
    padding-left: 15%;
  }

  .md\\:text-left {
    text-align: left;
  }

  .md\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .md\\:text-\\[1\\.13rem\\] {
    font-size: 1.13rem;
  }

  .md\\:text-\\[2\\.8rem\\] {
    font-size: 2.8rem;
  }

  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-\\[1\\.4rem\\] {
    font-size: 1.4rem;
  }

  .md\\:text-\\[1\\.6rem\\] {
    font-size: 1.6rem;
  }

  .md\\:text-\\[2\\.5rem\\] {
    font-size: 2.5rem;
  }

  .md\\:text-\\[3\\.45rem\\] {
    font-size: 3.45rem;
  }

  .md\\:text-\\[3\\.75rem\\] {
    font-size: 3.75rem;
  }

  .md\\:text-\\[4\\.4rem\\] {
    font-size: 4.4rem;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:font-bold {
    font-weight: 700;
  }

  .md\\:font-semibold {
    font-weight: 600;
  }

  .md\\:leading-6 {
    line-height: 1.5rem;
  }

  .md\\:leading-9 {
    line-height: 2.25rem;
  }

  .md\\:leading-\\[2\\.9rem\\] {
    line-height: 2.9rem;
  }

  .md\\:leading-tight {
    line-height: 1.25;
  }

  .md\\:text-black {
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity));
  }

  .before\\:md\\:mb-\\[58px\\]::before {
    content: var(--tw-content);
    margin-bottom: 58px;
  }
}

@media (min-width: 1024px) {

  .lg\\:order-1 {
    order: 1;
  }

  .lg\\:order-2 {
    order: 2;
  }

  .lg\\:m-5 {
    margin: 1.25rem;
  }

  .lg\\:my-20 {
    margin-top: 5rem;
    margin-bottom: 5rem;
  }

  .lg\\:mb-0 {
    margin-bottom: 0px;
  }

  .lg\\:mb-\\[52px\\] {
    margin-bottom: 52px;
  }

  .lg\\:ml-\\[28px\\] {
    margin-left: 28px;
  }

  .lg\\:mt-24 {
    margin-top: 6rem;
  }

  .lg\\:ml-\\[3\\.2rem\\] {
    margin-left: 3.2rem;
  }

  .lg\\:mt-0 {
    margin-top: 0px;
  }

  .lg\\:mt-10 {
    margin-top: 2.5rem;
  }

  .lg\\:mt-14 {
    margin-top: 3.5rem;
  }

  .lg\\:mt-16 {
    margin-top: 4rem;
  }

  .lg\\:mt-4 {
    margin-top: 1rem;
  }

  .lg\\:mt-5 {
    margin-top: 1.25rem;
  }

  .lg\\:mt-6 {
    margin-top: 1.5rem;
  }

  .lg\\:mt-9 {
    margin-top: 2.25rem;
  }

  .lg\\:mt-\\[4\\.4rem\\] {
    margin-top: 4.4rem;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:inline-block {
    display: inline-block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-\\[160px\\] {
    height: 160px;
  }

  .lg\\:h-16 {
    height: 4rem;
  }

  .lg\\:h-\\[202px\\] {
    height: 202px;
  }

  .lg\\:h-\\[528px\\] {
    height: 528px;
  }

  .lg\\:h-\\[822px\\] {
    height: 822px;
  }

  .lg\\:w-\\[160px\\] {
    width: 160px;
  }

  .lg\\:w-\\[calc\\(33\\.3\\%-56px\\)\\] {
    width: calc(33.3% - 56px);
  }

  .lg\\:w-auto {
    width: auto;
  }

  .lg\\:max-w-\\[1280px\\] {
    max-width: 1280px;
  }

  .lg\\:max-w-\\[1320px\\] {
    max-width: 1320px;
  }

  .lg\\:max-w-\\[1720px\\] {
    max-width: 1720px;
  }

  .lg\\:max-w-\\[500px\\] {
    max-width: 500px;
  }

  .lg\\:basis-auto {
    flex-basis: auto;
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:flex-col {
    flex-direction: column;
  }

  .lg\\:flex-wrap {
    flex-wrap: wrap;
  }

  .lg\\:items-start {
    align-items: flex-start;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:justify-normal {
    justify-content: normal;
  }

  .lg\\:justify-center {
    justify-content: center;
  }

  .lg\\:border-b-\\[1px\\] {
    border-bottom-width: 1px;
  }

  .lg\\:border-white {
    --tw-border-opacity: 1;
    border-color: rgb(255 255 255 / var(--tw-border-opacity));
  }

  .lg\\:bg-\\[url\\(\\"\\/public\\/assets\\/images\\/contact\\/bg_water\\.jpg\\"\\)\\] {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  }

  .lg\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .lg\\:py-28 {
    padding-top: 7rem;
    padding-bottom: 7rem;
  }

  .lg\\:py-32 {
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .lg\\:py-40 {
    padding-top: 10rem;
    padding-bottom: 10rem;
  }

  .lg\\:py-\\[1\\.6rem\\] {
    padding-top: 1.6rem;
    padding-bottom: 1.6rem;
  }

  .lg\\:py-\\[4\\.5rem\\] {
    padding-top: 4.5rem;
    padding-bottom: 4.5rem;
  }

  .lg\\:pt-40 {
    padding-top: 10rem;
  }

  .lg\\:pb-40 {
    padding-bottom: 10rem;
  }

  .lg\\:pt-32 {
    padding-top: 8rem;
  }

  .lg\\:text-left {
    text-align: left;
  }

  .lg\\:text-center {
    text-align: center;
  }

  .lg\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .lg\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .lg\\:text-\\[1\\.38rem\\] {
    font-size: 1.38rem;
  }

  .lg\\:text-\\[1\\.4rem\\] {
    font-size: 1.4rem;
  }

  .lg\\:text-\\[2\\.5rem\\] {
    font-size: 2.5rem;
  }

  .lg\\:text-\\[2\\.815rem\\] {
    font-size: 2.815rem;
  }

  .lg\\:text-\\[2\\.85rem\\] {
    font-size: 2.85rem;
  }

  .lg\\:text-\\[2\\.8rem\\] {
    font-size: 2.8rem;
  }

  .lg\\:text-\\[3\\.15rem\\] {
    font-size: 3.15rem;
  }

  .lg\\:text-\\[3\\.75rem\\] {
    font-size: 3.75rem;
  }

  .lg\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .lg\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .lg\\:leading-8 {
    line-height: 2rem;
  }

  .lg\\:leading-9 {
    line-height: 2.25rem;
  }

  .lg\\:leading-\\[1\\.1\\] {
    line-height: 1.1;
  }

  .lg\\:leading-\\[1\\.3\\] {
    line-height: 1.3;
  }

  .lg\\:leading-\\[1\\.5\\] {
    line-height: 1.5;
  }

  .lg\\:leading-\\[2\\.2rem\\] {
    line-height: 2.2rem;
  }

  .lg\\:leading-\\[3rem\\] {
    line-height: 3rem;
  }

  .lg\\:leading-\\[4\\.065rem\\] {
    line-height: 4.065rem;
  }

  .lg\\:leading-tight {
    line-height: 1.25;
  }

  .lg\\:text-black {
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity));
  }

  .lg\\:text-white {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }

  .placeholder\\:lg\\:text-2xl::placeholder {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .before\\:lg\\:mb-5::before {
    content: var(--tw-content);
    margin-bottom: 1.25rem;
  }
}

@media (min-width: 1280px) {

  .xl\\:mt-5 {
    margin-top: 1.25rem;
  }

  .xl\\:block {
    display: block;
  }

  .xl\\:inline {
    display: inline;
  }

  .xl\\:flex {
    display: flex;
  }

  .xl\\:hidden {
    display: none;
  }

  .xl\\:\\!h-full {
    height: 100% !important;
  }

  .xl\\:h-auto {
    height: auto;
  }

  .xl\\:h-full {
    height: 100%;
  }

  .xl\\:w-\\[40\\%\\] {
    width: 40%;
  }

  .xl\\:w-\\[45\\%\\] {
    width: 45%;
  }

  .xl\\:w-\\[55\\%\\] {
    width: 55%;
  }

  .xl\\:w-\\[60\\%\\] {
    width: 60%;
  }

  .xl\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .xl\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .xl\\:text-left {
    text-align: left;
  }

  .xl\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .xl\\:text-\\[2\\.5rem\\] {
    font-size: 2.5rem;
  }

  .xl\\:text-\\[3\\.75rem\\] {
    font-size: 3.75rem;
  }

  .xl\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .xl\\:leading-\\[3\\.8rem\\] {
    line-height: 3.8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;CAAc;;AAAd;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,4NAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AAEd;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB;2DAC+D;AACjE;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB;2DAC4D;AAC9D;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB;2DACkE;AACpE;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB;2DAC6D;AAC/D;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB;2DAC8D;AAChE;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB;2DACgE;AAClE;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB;2DAC4D;AAC9D;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB;2DACiE;AACnE;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB;2DAC6D;AAC/D;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,mCAAmC;AACrC;AACA;EACE,YAAY;AACd;;AAEA;;EAEE,UAAU;EACV,yCAAyC;AAC3C;;AAEA;;EAEE,UAAU;EACV,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AA5GA;EAAA,eA6GA;EA7GA;AA6GA;;AA7GA;EAAA,0BA6GA;EA7GA;AA6GA;;AA7GA;EAAA,0BA6GA;EA7GA;AA6GA;;AA7GA;EAAA,0BA6GA;EA7GA;AA6GA;;AA7GA;EAAA,0BA6GA;EA7GA;AA6GA;;AA7GA;EAAA,0BA6GA;EA7GA;AA6GA;;AA7GA;EAAA,0BA6GA;EA7GA;AA6GA;;AA7GA;EAAA,0BA6GA;EA7GA;AA6GA;;AA7GA;EAAA,0BA6GA;EA7GA;AA6GA;;AA7GA;EAAA,0BA6GA;EA7GA;AA6GA;;AA7GA;EAAA,0BA6GA;EA7GA;AA6GA;;AA7GA;EAAA,0BA6GA;EA7GA;AA6GA;;AA7GA;EAAA,0BA6GA;EA7GA;AA6GA;;AA7GA;EAAA,0BA6GA;EA7GA;AA6GA;;AA7GA;EAAA,0BA6GA;EA7GA,sBA6GA;EA7GA;AA6GA;;AA7GA;EAAA,0BA6GA;EA7GA,sBA6GA;EA7GA;AA6GA;;AA7GA;EAAA,0BA6GA;EA7GA;AA6GA;;AA7GA;EAAA,0BA6GA;EA7GA,kBA6GA;EA7GA;AA6GA;;AA7GA;EAAA,0BA6GA;EA7GA,kBA6GA;EA7GA;AA6GA;;AA7GA;EAAA,0BA6GA;EA7GA;AA6GA;;AA7GA;EAAA,0BA6GA;EA7GA,4BA6GA;EA7GA,wDA6GA;EA7GA;AA6GA;;AA7GA;EAAA,gBA6GA;EA7GA;AA6GA;;AA7GA;EAAA,sBA6GA;EA7GA;AA6GA;;AA7GA;EAAA,0BA6GA;EA7GA,kBA6GA;EA7GA;AA6GA;;AA7GA;EAAA,0BA6GA;EA7GA;AA6GA;;AA7GA;EAAA;AA6GA;;AA7GA;;EAAA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA,iBA6GA;IA7GA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA,kBA6GA;IA7GA;EA6GA;;EA7GA;IAAA,oBA6GA;IA7GA;EA6GA;;EA7GA;IAAA,oBA6GA;IA7GA;EA6GA;;EA7GA;IAAA,qBA6GA;IA7GA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA,eA6GA;IA7GA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA,mBA6GA;IA7GA;EA6GA;;EA7GA;IAAA,kBA6GA;IA7GA;EA6GA;;EA7GA;IAAA,iBA6GA;IA7GA;EA6GA;;EA7GA;IAAA,mBA6GA;IA7GA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA,mBA6GA;IA7GA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA,oBA6GA;IA7GA;EA6GA;;EA7GA;IAAA,0BA6GA;IA7GA;EA6GA;AAAA;;AA7GA;;EAAA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA,gBA6GA;IA7GA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA,sBA6GA;IA7GA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA,oBA6GA;IA7GA;EA6GA;;EA7GA;IAAA,iBA6GA;IA7GA;EA6GA;;EA7GA;IAAA,iBA6GA;IA7GA;EA6GA;;EA7GA;IAAA,kBA6GA;IA7GA;EA6GA;;EA7GA;IAAA,mBA6GA;IA7GA;EA6GA;;EA7GA;IAAA,mBA6GA;IA7GA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA,iBA6GA;IA7GA;EA6GA;;EA7GA;IAAA,mBA6GA;IA7GA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA,mBA6GA;IA7GA;EA6GA;;EA7GA;IAAA,kBA6GA;IA7GA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA,oBA6GA;IA7GA;EA6GA;;EA7GA;IAAA,oBA6GA;IA7GA;EA6GA;;EA7GA;IAAA,iBA6GA;IA7GA;EA6GA;;EA7GA;IAAA,0BA6GA;IA7GA;EA6GA;AAAA;;AA7GA;;EAAA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA,oBA6GA;IA7GA;EA6GA;;EA7GA;IAAA,qBA6GA;IA7GA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA,mBA6GA;IA7GA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA;EA6GA;;EA7GA;IAAA,kBA6GA;IA7GA;EA6GA;;EA7GA;IAAA;EA6GA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@font-face {\n  font-family: montserrat;\n  font-style: normal;\n  font-weight: 400;\n  src: local('Montserrat'),\n    url(/src/assets/fonts/Montserrat-Regular.woff) format('woff');\n}\n\n@font-face {\n  font-family: montserrat;\n  font-style: normal;\n  font-weight: 250;\n  src: local('Montserrat'),\n    url(/src/assets/fonts/Montserrat-Thin.woff) format('woff');\n}\n\n@font-face {\n  font-family: montserrat;\n  font-style: normal;\n  font-weight: 275;\n  src: local('Montserrat'),\n    url(/src/assets/fonts/Montserrat-ExtraLight.woff) format('woff');\n}\n\n@font-face {\n  font-family: montserrat;\n  font-style: normal;\n  font-weight: 300;\n  src: local('Montserrat'),\n    url(/src/assets/fonts/Montserrat-Light.woff) format('woff');\n}\n\n@font-face {\n  font-family: montserrat;\n  font-style: normal;\n  font-weight: 500;\n  src: local('Montserrat'),\n    url(/src/assets/fonts/Montserrat-Medium.woff) format('woff');\n}\n\n@font-face {\n  font-family: montserrat;\n  font-style: normal;\n  font-weight: 600;\n  src: local('Montserrat'),\n    url(/src/assets/fonts/Montserrat-SemiBold.woff) format('woff');\n}\n\n@font-face {\n  font-family: montserrat;\n  font-style: normal;\n  font-weight: 700;\n  src: local('Montserrat'),\n    url(/src/assets/fonts/Montserrat-Bold.woff) format('woff');\n}\n\n@font-face {\n  font-family: montserrat;\n  font-style: normal;\n  font-weight: 800;\n  src: local('Montserrat'),\n    url(/src/assets/fonts/Montserrat-ExtraBold.woff) format('woff');\n}\n\n@font-face {\n  font-family: montserrat;\n  font-style: normal;\n  font-weight: 900;\n  src: local('Montserrat'),\n    url(/src/assets/fonts/Montserrat-Black.woff) format('woff');\n}\n\nhtml,\nbody {\n  min-height: 100%;\n  height: 100%;\n  font-family: montserrat, sans-serif;\n}\n#root {\n  height: 100%;\n}\n\n.swiper-slide-active .fade-01,\n.swiper-slide-prev .fade-01 {\n  opacity: 0;\n  animation: fadeIn 1s ease-in-out forwards;\n}\n\n.swiper-slide-active .fade-02,\n.swiper-slide-prev .fade-02 {\n  opacity: 0;\n  animation: fadeIn 1s ease-in-out forwards;\n  animation-delay: 300ms;\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n    transform: translateY(100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
